@use 'styles/functions/rem' as *;

.gridContainer {
    display: grid;
    gap: rem(5px);
    grid-auto-flow: row;
    width: 100%;
}
